const PercentageIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 3.5L3.5 12.5M13 11.25C13 12.2165 12.2165 13 11.25 13C10.2835 13 9.5 12.2165 9.5 11.25C9.5 10.2835 10.2835 9.5 11.25 9.5C12.2165 9.5 13 10.2835 13 11.25ZM6.5 4.75C6.5 5.7165 5.7165 6.5 4.75 6.5C3.7835 6.5 3 5.7165 3 4.75C3 3.7835 3.7835 3 4.75 3C5.7165 3 6.5 3.7835 6.5 4.75Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default PercentageIcon;
